import React from "react";
import { Computer } from "@resources";
import { useNavigate } from 'react-router-dom';

const ResetPasswordSuccess = () => {

    const navigate = useNavigate();

    return (
        <div className="page-content-wrapper">
            <Computer className="h-56" />

            <h1 className="page-header">Congratulations! You have reset your password</h1>
            <div className="page-action">
                <button type="button" onClick={() => navigate(`/`)} className="btn btn-primary h-14 mt-7 text-lg font-bold rounded-full">Go to Dashboard</button>
            </div>
        </div>

    );
};

export default ResetPasswordSuccess;

